"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLoading = exports.LoadingModel = void 0;
const NumberModel_1 = require("./NumberModel");
class LoadingModel {
    constructor(useFirstInit = false) {
        this._number = new NumberModel_1.NumberModel(0);
        this.reset = () => {
            this._firstInit = false;
            this._number.reset();
        };
        this._firstInit = useFirstInit;
    }
    get isLoading() { return this.value || this._firstInit; }
    get value() { return this._number.value > 0; }
    set value(v) {
        if (v) {
            this._number.increment();
        }
        else {
            this._firstInit = false;
            this._number.decrement();
        }
    }
    useLoading(cb, exclusive = false) {
        return withLoading(this, cb, exclusive);
    }
}
exports.LoadingModel = LoadingModel;
async function withLoading(model, cb, exclusive = false) {
    if (exclusive && model.value) {
        if (exclusive === 'throw') {
            throw new Error('Operation cannot be started because another one is in progress already.');
        }
        return false;
    }
    model.value = true;
    try {
        const res = await cb();
        return res;
    }
    finally {
        model.value = false;
    }
}
exports.withLoading = withLoading;
//# sourceMappingURL=LoadingModel.js.map